/**
 * Created by guoliangfang on 2017/8/24.
 */
import _ from 'lodash';
import React from 'react';

import {Tree} from 'antd';
const TreeNode = Tree.TreeNode;

class UserPermissionTree extends React.Component {

    static refactorArrayToTree(data, pid) {
        const parent_id = pid || 0;
        const left_data = [];
        const parent = data.filter((item) => {
            if (parent_id == item.pid) {
                return item;
            } else {
                left_data.push(item);
            }
        });
        if (parent.length > 0) {
            return parent.map((item) => {
                const left = left_data.filter((left) => {
                    return left.pid == item.id;
                });
                if (left.length > 0) {
                    item.children = [...UserPermissionTree.refactorArrayToTree(left_data, item.id)];
                    return item;
                } else {
                    return item;
                }
            });
        }
    }

    constructor(props) {
        super(props);
        const{rolesPermissionList,selectedPermission} = props;
        this.state={
            defaultSelect:rolesPermissionList || [],
            selectedPermissions:selectedPermission || []
        };
        this.disabledNodes = [];
    }

    componentWillReceiveProps(nextProps) {
        const{permissions,rolesPermissionList,selectedPermission} = nextProps;
        if (permissions) {
            this.setState({
                defaultSelect: rolesPermissionList.length>0 ? rolesPermissionList.toString().split(','):[],
                selectedPermissions:selectedPermission.length>0 ? selectedPermission.toString().split(','):[],
                permissions: UserPermissionTree.refactorArrayToTree(permissions)
            });
        }
    }

    shouldDisabled(data, id) {
        return data.filter((item) => {
            if (item.id == id) {
                return true;
            } else if (item.children.length > 0) {
                return this.shouldDisabled(item.children, id);
            }
        });
    }

    getTreeNode(data) {
        if (!data) {
            return;
        }
        return data.map((item) => {
            const disabled = this.disabledNodes.indexOf(item.id.toString()) > -1;
            return (
                <TreeNode title={item.display_name} key={item.id} disabled={disabled}>
                    {this.getTreeNode(item.children)}
                </TreeNode>
            );
        });
    }




    onCheck(checkedKeys, info) {
        const {checkedNodes} = info;
        const keys = checkedNodes.filter((item)=>{
            return !item.props.children;
        }).map((item)=>{
            return item.key;
        });

        const selectedPermissions = _.difference(keys,this.state.defaultSelect);
        this.setState({selectedPermissions});
        this.props.setPermissionTree(selectedPermissions);
    }
    parseDisableNode(tree,hasSelects){
        let allDis = true;
        let disNum = 0;
        for(const i in tree){
            const item = tree[i];
            
            if(item.children){
                const _allChildrenDis = this.parseDisableNode(item.children,hasSelects);
                if(_allChildrenDis){
                    disNum ++ ;
                    this.disabledNodes.push(item.id.toString());
                }
                
                if(i == tree.length-1 && disNum != tree.length){
                    allDis = false;
                }
                
            }else{
                if(hasSelects.indexOf(item.id.toString()) > -1){
                    this.disabledNodes.push(item.id.toString());
                }else{
                    allDis = false;
                }
                
            }
        }
        return allDis;
    }

    render() {
        this.disabledNodes = [];
        this.parseDisableNode(this.state.permissions,this.state.defaultSelect);
        const treeNode = this.getTreeNode(this.state.permissions);
        const {defaultSelect, selectedPermissions} = this.state;
        const checkedKeys = defaultSelect.concat(selectedPermissions);
        let theTree;
        if (treeNode) {
            theTree = (
                <Tree
                    checkable
                    defaultExpandAll
                    checkedKeys={checkedKeys}
                    onCheck={this.onCheck.bind(this)}
                >
                    {treeNode}
                </Tree>
            );
        }
        return (
            <div className="user-permission-tree" style={{display: this.props.show ? 'block' : 'none'}}>
                {theTree}
            </div>
        );
    }
}

UserPermissionTree.defaultProps = {};

export default UserPermissionTree;



// WEBPACK FOOTER //
// ./src/pages/SubAccountManagement/UserPermissionTree/index.js